/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Flowvolume1Inputs */



/**
* | output |
* | --- |
* | "Flow volume" |
*
* @param {Br_History_Key_Flowvolume1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_flowvolume1 = /** @type {((inputs?: Br_History_Key_Flowvolume1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Flowvolume1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Flow volume")
	return /** @type {LocalizedString} */ ("Débit")
});
export { br_history_key_flowvolume1 as "br_history_key_flowVolume" }